import instance from "../utils/request";
import { Login } from "@/model/login";
import { jyj_columnsecond_management, Res } from "@/model/requestModel";

/**
 * 登录
 */
export const login = (params: object): Res<Login> =>
  instance.post(process.env.VUE_APP_LOGIN_API, params);

/**
 * 文件上传
 */
export const uploadUrl = (file): Res<Object> =>
  instance.post("/sys/common/upload", file, {
    headers: { "content-type": "application/x-www-form-urlencoded" },
  });

/**
 * 查询仓库授权
 */
export const queryLoginSchool = (params: object): Res<Object> =>
  instance.get("/jeecg-school/school/xxUserAuthorization/queryLoginSchool", {
    params,
  });

/**
 * 查询领用单位授权
 */
export const queryRecipientsUnitTree = (params: object): Res<any[]> =>
  instance.get(
    "/jeecg-school/school/xxRecipientsUnitManager/queryRecipientsUnitTree",
    { params },
  );

/**
 * 用户授权管理表-添加
 */
export const xxUserAuthorizationAdd = (params: object): Res<Object> =>
  instance.post("/jeecg-school/school/xxUserAuthorization/add", params);

/**
 * 查询需求单位下拉数据
 */
export const queryAuthUnit = (params: object): Res<any> =>
  instance.get("/jeecg-school/school/xxDemandPlanning/queryAuthUnit", {
    params,
  });

/**
 * 查询需求单位下拉数据
 */
export const queryUnit = (params: object): Res<any> =>
  instance.get("/school/xxDemandPlanning/queryUnit", { params });

/**
 * 采购入库
 */
export const xxStockManagementList = (
  params: object,
): Res<jyj_columnsecond_management<[]>> =>
  instance.get("/school/xxStockManagement/list", { params });

/**
 * 收货
 */
export const warehousing = (
  params: object,
): Res<jyj_columnsecond_management<string>> =>
  instance.post("/jeecg-school/school/xxStockManagement/warehousing", params);

/**
 * 查询单据下的商品
 */
export const queryFoodsByStockId = (params: object): Res<[]> =>
  instance.get("/jeecg-school/school/xxStockManagement/queryFoodsByStockId", {
    params,
  });

/**
 * 查询分组下的类目列表
 */
export const queryFoodGroupByGroupId = (params: object): Res<[]> =>
  instance.get(
    "/jeecg-education/education/jyjFoodGroup/queryFoodGroupByGroupId",
    { params },
  );

/**
 * 学校查询供应商的供应商品分页列表
 */
export const schoolFoodsList = (
  params: object,
): Res<jyj_columnsecond_management<[]>> =>
  instance.get(
    "/jeecg-education/education/jyjSupplyGoods/querySortingAddFoodsList",
    { params },
  );

/**
 * 分拣-保存入库食材称重信息
 */
export const addWeighingInformation = (params: object): Res<string> =>
  instance.post(
    "/jeecg-school/school/xxStockManagement/addWeighingInformation",
    params,
  );

/**
 * 查询学校下的供应商
 */
export const querySuppliersBySchool = (params: object): Res<[]> =>
  instance.get(
    "/jeecg-education/education/jyjSchoolManage/querySuppliersBySchool",
    { params },
  );

/**
 * 查询字典项
 */
export const getDictItemsByCode = (params: string): Res<[]> =>
  instance.get(`/jeecg-system/sys/dictItem/getDictItemsByCode/${params}`);

/**
 * 分拣-添加入库食材
 */
export const addIngredients = (params: any): Res<[]> =>
  instance.post(
    `/jeecg-school/school/xxStockManagement/addIngredients`,
    params,
  );

/**
 * 供应商-订单列表
 */
export const gysDistributionManagementList = (
  params: any,
): Res<jyj_columnsecond_management<[]>> =>
  instance.get(`supplier/gysDistributionManagement/list`, { params });

/**
 * 供应商-订单列表的食材列表
 */
export const queryByIdOrDistributionNo = (params: any): Res<[]> =>
  instance.get(
    `/jeecg-supplier/supplier/gysDistributionGoods/queryByIdOrDistributionNo`,
    { params },
  );

/**
 * 供应商-订单列表-添加食材列表
 */
export const queryFoodsPageListBySchoolId = (params: any): Res<[]> =>
  instance.get(
    `/jeecg-supplier/supplier/supplier/queryFoodsPageListBySchoolId`,
    { params },
  );

/**
 * 供应商-订单列表--分拣称重食材编辑
 */
export const gysDistributionGoodsEdit = (params: any): Res<string> =>
  instance.post(`/jeecg-supplier/supplier/gysDistributionGoods/edit`, params);

/**
 * 供应商-分拣系统配送商品-添加
 */
export const sortingAdd = (params: any): Res<string> =>
  instance.post(
    `/jeecg-supplier/supplier/gysDistributionManagement/edit`,
    params,
  );

/**
 * 供应商-去配送
 */
export const gysDistributionManagementEdit = (params: any): Res<string> =>
  instance.post(`/supplier/gysDistributionManagement/edit`, params);

/**
 * 供应商-需求单位
 */
export const querySchoolList = (params: any): Res<[]> =>
  instance.get(`/jeecg-supplier/supplier/gysOrderManagement/querySchoolList`, {
    params,
  });

/**
 * 供应商-食材删除
 */
export const gysDistributionGoodsDelete = (params: any): Res<string> =>
  instance.delete(`/supplier/gysDistributionGoods/delete`, { data: params });

/**
 * 学校-食材删除
 */
export const deleteFoodInformation = (params: any): Res<string> =>
  instance.post(
    `/jeecg-school/school/xxStockManagement/deleteFoodInformation`,
    params,
  );

/**
 * 分拣-免称重
 */
export const noWeighing = (params: any): Res<string> =>
  instance.post(`/jeecg-school/school/xxStockManagement/noWeighing`, params);

/**
 * 教育局学期管理-查询学期下拉数据
 */
export const queryAllList = (params: any): Res<any[]> =>
  instance.get(
    `/jeecg-education/education/jyjSemesterManage/queryAllList`,
    params,
  );

/**
 * 教育局学期管理-学期周查询
 */
export const queryWeekList = (params: any): Res<any[]> =>
  instance.get(`/jeecg-education/education/jyjSemesterManage/queryWeekList`, {
    params,
  });

/**
 * 详情-详情中查询日期tabs数据
 */
export const queryXxRecipesSemesterById = (params: any): Res<any[]> =>
  instance.get(
    `/jeecg-school/school/xxBringRecipes/queryXxRecipesSemesterById`,
    { params },
  );

/**
 * 获取教育局下的系统参数
 */
export const queryAllConfig = (params: any): Res<any[]> =>
  instance.get(`/jeecg-education/education/jyjSysConfig/queryAllConfig`, {
    params,
  });

/**
 * 供应出库-列表
 */
export const xxSupplyOutManagementList = (params: any): Res<any[]> =>
  instance.get(`/jeecg-school/school/xxSupplyOutManagement/list`, { params });

/**
 * 供应出库-删除
 */
export const xxSupplyOutManagementDelete = (params: any): Res<string> =>
  instance.delete(`/school/xxSupplyOutManagement/delete`, { params });

/**
 * 供应出库-获取食材
 */
export const xxSupplyOutManagementQueryById = (params: any): Res<any> =>
  instance.get(`/jeecg-school/school/xxSupplyOutManagement/queryById`, {
    params,
  });

/**
 * 供应出库-添加食材列表
 */
export const listRealTimeInventoryPage = (params: any): Res<any> =>
  instance.get(
    `/jeecg-school/school/xxRealTimeInventory/listRealTimeInventoryPageFilter`,
    { params },
  );

/**
 * 供应出库-出库
 */
export const xxSupplyOutManagementAdd = (params: any): Res<any> =>
  instance.post(`/jeecg-school/school/xxSupplyOutManagement/add`, params);

/**
 * 分拣出库-删除食材
 */
export const deleteFood = (params: any): Res<string> =>
  instance.delete(`/jeecg-school/school/xxSupplyOutManagement/deleteFood`, {
    data: params,
  });

/**
 * 分拣出库-保存入库食材称重信息
 */
export const addWeighingInformationOutbound = (params: any): Res<string> =>
  instance.post(
    `/jeecg-school/school/xxSupplyOutManagement/addWeighingInformation`,
    params,
  );

/**
 * 分拣出库-免称重
 */
export const xxSupplyOutManagementNoWeighing = (params: any): Res<string> =>
  instance.post(
    `/jeecg-school/school/xxSupplyOutManagement/noWeighing`,
    params,
  );

/**
 * 补货
 */
export const replenishment = (params: any): Res<string> =>
  instance.post(`/jeecg-school/school/xxStockManagement/replenishment`, params);

/**
 * 补货添加商品
 */
export const queryReplenishmentFoods = (params: any): Res<any> =>
  instance.get(
    `/jeecg-school/school/xxStockManagement/queryReplenishmentFoods`,
    { params },
  );

/**
 * 获取系统参数
 */
export const queryConfigByIdentifier = (params: any): Res<any> =>
  instance.get(
    `/jeecg-education/education/jyjSysConfig/queryConfigByIdentifier`,
    { params },
  );

/**
 * 称重确认之后截取当前时间前10秒视频
 */
export const cacheVideoFirstTenTime = (params: any): Res<any> =>
  instance.get(`/jeecg-system/sys/video/cacheVideoFirstTenTime`, { params });

/**
 * 分拣-查询订单类型数量
 */
export const numberOfTypes = (params: any): Res<any> =>
  instance.get(`/jeecg-school/school/xxStockManagement/numberOfTypes`, {
    params,
  });

/**
 * 续重-保存续重
 */
export const saveWeightContinuation = (params: any): Res<any> =>
  instance.post(
    `/jeecg-school/school/xxStockManagement/saveWeightContinuation`,
    params,
  );

/**
 * 续重-撤销
 */
export const revokeWeightContinuation = (params: any): Res<any> =>
  instance.post(
    `/jeecg-school/school/xxStockManagement/revokeWeightContinuation`,
    params,
  );

/**
 * 续重-续重列表
 */
export const listWeightContinuation = (params: any): Res<any> =>
  instance.post(
    `/jeecg-school/school/xxStockManagement/listWeightContinuation`,
    params,
  );

/**
 * 续重-消除或关闭
 */
export const eliminateWeightContinuation = (params: any): Res<any> =>
  instance.post(
    `/jeecg-school/school/xxStockManagement/eliminateWeightContinuation`,
    params,
  );

/**
 * 签字
 */
export const sign = (params: any): Res<any> =>
  instance.post(`/jeecg-school/school/xxStockManagement/sign`, params);

/**
 * 签字
 */
export const queryVersions = (params: any): Res<any> =>
  instance.get(`/jeecg-system/sys/queryVersions`, { params });

/**
 * 状态数量统计
 */
export const statusQuantityStatistics = (params: any): Res<any> =>
  instance.get(`/school/xxStockManagement/statusQuantityStatistics`, {
    params,
  });

//=========== 新建单据 ==========
/**
 * 获取数据字典
 */
export const getDictItems = (dictCode: any): Res<any> =>
  instance.get(`/sys/dictItem/getDictItemsByCode/${dictCode}`);

/**
 * 分拣-保存单据
 */
export const addSortingStock = (params: any): Res<any> =>
  instance.post(
    `/jeecg-school/school/xxStockManagement/addSortingStock`,
    params,
  );

/**
 * 分拣-添加食材-出库
 */
export const addFood = (params: any): Res<any> =>
  instance.post(`/jeecg-school/school/xxSupplyOutManagement/addFood`, params);

/**
 * 分拣-保存单据-出库
 */
export const xxSupplyOutManagementAddSortingStock = (params: any): Res<any> =>
  instance.post(
    `/jeecg-school/school/xxSupplyOutManagement/addSortingStock`,
    params,
  );

/**
 * 获取学校下的单个系统参数
 */
export const xxSysConfigQueryConfigByIdentifier = (params: any): Res<any> =>
  instance.get(`/jeecg-school/school/xxSysConfig/queryConfigByIdentifier`, {
    params,
  });

/**
 * 获取学校设备是否打印机
 */
export const queryEquipmentBySchoolId = (params: any): Res<any> =>
  instance.get(
    `/jeecg-system/sys/sysEquipmentManager/queryEquipmentBySchoolId`,
    { params },
  );

/**
 * 供应出库签字
 */
export const supplyOutManagementSign = (params: any): Res<any> =>
  instance.post(`/jeecg-school/school/xxSupplyOutManagement/sign`, params);

/**
 * 食材分拣-标签数字
 */
export const queryTagNumber = (params: any): Res<any> =>
  instance.get(`/jeecg-school/school/xxStockManagement/queryTagNumber`, params);

/**
 * 食材分拣-查询待称重计件食材列表
 */
export const queryFoodsToBeReceived = (params: any): Res<any> =>
  instance.get(
    `/jeecg-school/school/xxStockManagement/queryFoodsToBeReceived`,
    { params },
  );

/**
 * 食材分拣-查询食材列表
 */
export const queryFoodsByFoodId = (params: any): Res<any> =>
  instance.get(`/jeecg-school/school/xxStockManagement/queryFoodsByFoodId`, {
    params,
  });

/**
 * 食材分拣-查询食材列表
 */
export const queryAcceptableOrders = (params: any): Res<any> =>
  instance.get(`/jeecg-school/school/xxStockManagement/queryAcceptableOrders`, {
    params,
  });

/**
 * 食材分拣-查询类型数量
 */
export const queryFoodsWeightNum = (params: any): Res<any> =>
  instance.get(`/jeecg-school/school/xxStockManagement/queryFoodsWeightNum`, {
    params,
  });

/**
 * 账号切换列表
 */
export const queryUserList = (params: any): Res<any> =>
  instance.get(`/sys/user/queryUserList`, {
    params,
  });

/**
 * 食材分拣-查询类型数量
 */
export const switchLogin = (params: any): Res<any> =>
  instance.post(`/sys/switchLogin`, params);

/**
 * 电子秤查询领用单位
 */
export const queryRecipientsUnitList = (params?: any): Res<any> =>
  instance.get(`/school/xxRecipientsUnitManager/queryRecipientsUnitList`, {
    params,
  });

/**
 * 清空去皮重量
 */
export const clearAndPeel = (params?: any): Res<any> =>
  instance.post(`/school/xxStockManagement/clearAndPeel`, params);

/**
 * 请求教学视频
 */
export const queryFrequentlyQuestions = (params?: any): Res<any> =>
  instance.get(`/sys/frequentlyQuestions/queryFrequentlyQuestions`, {
    params,
  });

  /**
 * 请求教学视频
 */
export const queryBySchoolId = (params?: any): Res<any> =>
  instance.get(`/school/xxElectronicConfig/queryBySchoolId`, {
    params,
  });
